<template>
  <mdb-container>
    <mdb-row>
      <mdb-col>
        <Errors v-show="!!error" :error="error" />
        <div v-show="showSpinner">
          <Spinner />
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-tbl striped class="wide">
        <mdb-tbl-head>
          <tr>
            <th>Location</th>
            <th>Scan State</th>
            <th>Created On</th>
            <th>Action</th>
          </tr>
        </mdb-tbl-head>

        <transition-group tag="tbody" name="fade">
          <tr v-for="station in stationList.rows" :key="station.id">
            <td>{{ station.location }}</td>
            <td>{{ station.scan_state }}</td>
            <td>{{ station.created_at | formatDate }}</td>
            <td>
              <mdb-btn
                color="dark"
                v-on:click="removeStation(station)"
                outline="primary"
                icon="minus"
                size="sm"
                >Remove</mdb-btn
              >
            </td>
          </tr>
        </transition-group>
      </mdb-tbl>
    </mdb-row>

    <mdb-row>
      <mdb-modal :show="showDeleteModal" @close="showDeleteModal = false">
        <mdb-modal-header>
          <mdb-modal-title
            >Remove Station ({{ selectedStation.location }} -
            {{ selectedStation.scan_state }})
          </mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body
          >Do you want to permanently delete this station?
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn outline="primary" @click.native="showDeleteModal = false"
            >No</mdb-btn
          >
          <mdb-btn color="primary" v-on:click="deleteStation()"
            >Yes, Delete</mdb-btn
          >
        </mdb-modal-footer>
      </mdb-modal>
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import dateFns from "date-fns";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbDatatable,
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbTbl,
  mdbTblHead,
  mdbTblBody,
  mdbModal,
  mdbModalTitle,
  mdbModalHeader,
  mdbModalFooter,
  mdbModalBody,
} from "mdbvue";

export default {
  name: "stationList",
  props: {
    stations: {
      type: Array,
      required: true,
    },
  },

  filters: {
    formatDate(date) {
      return dateFns.format(date, "MMMM Do [at] h:mm a");
    },
  },
  components: {
    mdbContainer,
    mdbDatatable,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbModal,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    Spinner,
    Errors,
  },
  data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      selectedStation: {},
      error: "",
      stationList: {
        rows: [],
      },
    };
  },
  created() {
    this.stationList.rows = this.stations;
    this.isLoading = false;
  },
  methods: {
    removeStation(station) {
      this.selectedStation = station;
      this.showDeleteModal = true;
    },

    deleteStation() {
      this.isLoading = true;
      this.showDeleteModal = false;
      api
        .deleteStation(this.selectedStation.id)
        .then((response) => {
          this.stationList.rows = [...response.data];
          this.isLoading = false;
        })
        .catch((e) => {
          this.error = e.response.data.errors.full_messages[0];
        });
    },
  },
  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
};
</script>

<style scoped lang="scss">
.wide {
  width: 80vw;
}
</style>
